import React from 'react';
import envConfig from '../../../config/env';
/**
 * 20210126 自動職缺零筆 也不顯示
 */
class CompanyJobs extends React.Component {

    constructor(props){
        super(props);
        this.state={};
    }

    componentDidMount(){
        const cid = this.props.match.params.cid;
        this.props.getPositionList(cid, this.props.themeNum);
        this.props.getPositionGrpList(cid, this.props.themeNum);
        this.props.getkind00(cid);
    }

    render(){
        const { positionGrpData } = this.props.positionGrpReducer;
        const { positionData } = this.props.positionReducer;
        const { kind00Data } = this.props.kind00Reducer;
        let isAutoPosition=0;//add 20201207
        const limitCount=envConfig.PositionCount;

        if(positionGrpData && positionGrpData.length > 0){
            positionGrpData.forEach( element  => {
            isAutoPosition=element.position_IsAuto;
            })     
        }
        let positionURL2 = "https://www.1111.com.tw/job/";
        let owlLists = [];
        if(isAutoPosition===0){
            Array.isArray(positionData) && positionData.filter( data => data.position_group === "1").forEach((element, index) => {
                let positionURL = positionURL2+ element.eNo + "/";
                owlLists.push(                   
                    <div key={index} className="testimonial-item testimonial-item--2">
                        <a target="_blank" href={positionURL} rel="noopener noreferrer">
                         <div className="client-quote">
                            <h5 className="text-brand">{element.position_name}</h5>
                         </div>

                        <div className="client-info">
                            <h6 className="client-title">{element.position_salary}</h6>
                            <span className="client-designation">{element.position_workCity}</span>
                            <p className="line-3">{element.position_matter}</p>
                        </div>
                        </a>
                        <div className="button-item mt-15">
                             <a target="_blank" href={positionURL} rel="noopener noreferrer" className="btn-brand btn-lg text-white">我要應徵</a>
                        </div>
                    </div>
                )
            })
        }
        else if(isAutoPosition===1){          
            Array.isArray(kind00Data) && kind00Data.forEach((element, index) => {
                let positionURL = positionURL2+ element.eNo + "/";
                if(index < limitCount){
                    owlLists.push(
                        
                        <div key={index} className="testimonial-item testimonial-item--2">
                            <a target="_blank" href={positionURL} rel="noopener noreferrer">
                            <div className="client-quote">
                                <h5 className="text-brand">{element.Position}</h5>
                            </div>

                            <div className="client-info">
                                <h6 className="client-title">{element.Salary}</h6>
                                <span className="client-designation">{element.WorkCity}</span>
                                <p className="line-3">{element.Matter}</p>
                            </div>
                            </a>
                            <div className="button-item mt-15">
                                <a target="_blank" href={positionURL} rel="noopener noreferrer" className="btn-brand btn-lg text-white">我要應徵</a>
                            </div>
                        </div>
                    )
                }
            })
        }
        return (
            <div id="jobs" className="testimonial-landing-area custom-top" 
                 style={((isAutoPosition===0 && positionData.length <= 0) 
                 || (isAutoPosition===1 && (kind00Data.length <= 0 || (kind00Data.length===1 && kind00Data[0].oNo===0)))
                 ) ? {display: 'none'} :{}}>
            <style>
              {((isAutoPosition===0 && positionData.length <= 0) 
              || (isAutoPosition===1 && (kind00Data.length <= 0 || (kind00Data.length===1 && kind00Data[0].oNo===0)))
              ) && `.job-display {display:none !important;}`}
            </style>     
            <div className="container">
                    <div className="row">
                        <div className="col-lg-6 m-auto text-center">
                            <div className="section-title mb-0">
                                <h5>jobs</h5>
                                <h4 className="font-weight-bold">熱門職缺</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-9 m-auto">
                            <div className="testimonial-content-landing job-min-height">{owlLists}
                                
                                {/* 
                                {Array.isArray(positionData) && positionData.filter( data => data.position_group === "1").map((element, index) => {
                                    let positionURL = "https://www.1111.com.tw/job/"+ element.eNo + "/";

                                    return(
                                
                                <div key={index} className="testimonial-item testimonial-item--2">
                                     *************************************************************************************原區塊助解，配合外層全部住解所以拿掉這區塊注解，還原要註解調
                                    <figure className="client-thumb">
                                        <img src="../../../image/tp03/jobs/jobs_logo_01.png" alt="1111人力銀行職缺介紹" />
                                    </figure>
                                     *************************************************************************************原區塊助解       
                                    <div className="client-quote">
                                        <h5 className="text-brand">{element.position_name}</h5>
                                    </div>

                                    <div className="client-info">
                                        <h6 className="client-title">{element.position_salary}</h6>
                                        <span className="client-designation">{element.position_workCity}</span>
                                        <p className="line-3">{element.position_matter}</p>
                                    </div>
                                    <div className="button-item mt-15">
                                        <a target="_blank" href={positionURL} rel="noopener noreferrer" className="btn-brand btn-lg text-white">我要應徵</a>
                                    </div>
                                </div>

                                    )    
                                 })} 
                                    */}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}

export default CompanyJobs;